import {fetch, post} from './http'

function loggedIn () {
  var promise = new Promise((resolve, reject) => {
    let isAuthenticated = app.$store.getters['auth/isAuthenticated'], sessionId = app.$store.getters['auth/SESSIONID']
    if (isAuthenticated) {
      resolve()
    } else if (sessionId) {
      return post('security/token', {}, {quiet: true}).then(res => {
        app.$store.dispatch('auth/login', res.value)
        resolve()
      }).catch(err => {
        reject(err)
      })
    }
    reject()
  })

  return promise
}

function getToken () {
  let isAuthenticated = app.$store.getters['auth/isAuthenticated'], token = app.$store.getters['auth/token']
  if (isAuthenticated) {
    return token
  }
  return {}
}

export default {
  loggedIn,
  getToken
}



// WEBPACK FOOTER //
// ./src/utils/auth.js